import Icon from '../components/Icon.vue'

Icon.register({
  bullhorn: {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M576 240c0 23.6-13 44-32 55.1v152.9c0 9.2-7.1 32-32 32-6.2 0-15.1-3.2-20-7l-85-68c-42.7-34.1-96.3-53-151-53h-28.1c-2.8 10.2-4.4 20.9-4.4 32 0 29.1 9.8 55.9 26.2 77.4 15.8 20.7 0.1 50.6-25.9 50.6h-74.3c-11.9 0-23.2-6.4-28.4-17.1-16.3-33.6-25.6-71.2-25.6-110.9 0-10.9 0.8-21.5 2.2-32h-33.7c-35.3 0-64-28.7-64-64v-96c0-35.3 28.7-64 64-64h192c54.7 0 108.3-18.8 151-53l85-68c5.8-4.6 12.9-7 20-7 25 0 32 23.3 32 32v152.9c19 11.1 32 31.5 32 55.1zM480 381.4v-282.8l-33 26.4c-54 43.2-121.8 67-190.9 67v96c69.1 0 136.9 23.8 190.9 67z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/bullhorn.js
// module id = 1124
// module chunks = 0